module.exports = __webpack_public_path__ + "img/no-image.baf1faea.png";